import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalService,
} from '@azure/msal-angular';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { JwtInterceptor } from '@core/services/jwt.interceptor';
import { FundProfileInterceptor, ErrorInterceptor, EncodingInterceptor } from '@core/services';
import { LanguageInterceptor } from '@core/services/language.interceptor';
import { AuthService } from './services/auth.service';
import { PublicClientApplication } from '@azure/msal-browser';

export function provideAuth() {
  return [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: EncodingInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: FundProfileInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LanguageInterceptor,
      multi: true,
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: (authService: AuthService) => {
        // Get the instance once - don't call msalInstance() repeatedly
        const instance = authService.msalInstance();
        return instance ?? new PublicClientApplication({ auth: { clientId: '' } });
      },
      deps: [AuthService],
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: (authService: AuthService) => {
        // Return the computed value directly - Angular DI will cache it
        return authService.msalGuardConfig();
      },
      deps: [AuthService],
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: (authService: AuthService) => {
        // Return the computed value directly - Angular DI will cache it
        return authService.msalInterceptorConfig();
      },
      deps: [AuthService],
    },
    MsalService,
    MsalBroadcastService,
  ];
}
